import { render, staticRenderFns } from "./ZddAddMember.vue?vue&type=template&id=56da52c0&scoped=true"
import script from "./ZddAddMember.vue?vue&type=script&lang=js"
export * from "./ZddAddMember.vue?vue&type=script&lang=js"
import style0 from "./ZddAddMember.vue?vue&type=style&index=0&id=56da52c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da52c0",
  null
  
)

export default component.exports